import React, { useState, useEffect } from "react";
import { Stack, Switch, Paper, Typography, TextField, Button, FormControl, InputLabel, Select, MenuItem,
        Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { systemsIntegrationAxios as axios } from '../../utils/AxiosUtility';
import Countdown, { zeroPad } from "react-countdown";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import MuiPhoneNumber from 'mui-phone-number';
import validator from 'validator';

const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const timeZones = [
  { label: "Eastern Standard", value: "Eastern Standard Time" },
  { label: "Central Standard", value: "Central Standard Time" },
  { label: "Mountain Standard", value: "Mountain Standard Time" },
  { label: "Pacific Standard", value: "Pacific Standard Time" },
  { label: "Western Indonesian", value: "Western Indonesian Time" },
  { label: "Eastern European", value: "Eastern European Time" },
  { label: "South Africa Standard", value: "South Africa Standard Time" },
  { label: "Central European", value: "Central European Time" },
  { label: "GMT Standard", value: "GMT Standard Time" },
  { label: "Brasilia Standard", value: "Brasilia Standard Time" },
  { label: "Colombia Standard", value: "Colombia Standard Time" },
  { label: "Australian Eastern Standard", value: "Australian Eastern Standard Time" },
  { label: "Philippine Standard", value: "Philippine Standard Time" },
  { label: "New Zealand Standard", value: "New Zealand Standard Time" },
  { label: "Singapore Standard", value: "Singapore Standard Time" },
  { label: "Indochina", value: "Indochina Time" },
  { label: "Tokyo Standard", value: "Tokyo Standard Time" },
  { label: "Korea Standard", value: "Korea Standard Time" },
  { label: "China Standard", value: "China Standard Time" },
  { label: "Turkey Standard", value: "Turkey Standard Time" },
  { label: "India Standard", value: "India Standard Time" },
  { label: "Pakistan Standard", value: "Pakistan Standard Time" },
  { label: "Afghanistan", value: "Afghanistan Time" },
  { label: "Sri Lanka Standard", value: "Sri Lanka Standard Time" },
  { label: "Myanmar", value: "Myanmar Time" },
  { label: "Iran Standard", value: "Iran Standard Time" },
  { label: "Western European", value: "Western European Time" },
  { label: "Greenwich Mean", value: "Greenwich Mean Time" },
  { label: "West Africa", value: "West Africa Time" },
  { label: "Mauritius Standard", value: "Mauritius Standard Time" },
  { label: "Cape Verde Standard", value: "Cape Verde Standard Time" },
  { label: "Seychelles", value: "Seychelles Time" },
  { label: "Central Africa", value: "Central Africa Time" },
  { label: "East Africa", value: "East Africa Time" },
  { label: "Réunion", value: "Réunion Time" },
  { label: "South West Africa", value: "South West Africa Time" },
  { label: "Atlantic Standard", value: "Atlantic Standard Time" },
  { label: "Armenia Standard", value: "Armenia Standard Time" },
  { label: "Moscow Standard", value: "Moscow Standard Time" },
  { label: "Falkland Islands Standard", value: "Falkland Islands Standard Time" },
  { label: "Saint Pierre and Miquelon Standard", value: "Saint Pierre and Miquelon Standard Time" },
  { label: "Bolivia", value: "Bolivia Time" },
  { label: "Guyana", value: "Guyana Time" },
  { label: "Ecuador", value: "Ecuador Time" },
  { label: "Paraguay", value: "Paraguay Time" },
  { label: "Suriname", value: "Suriname Time" },
  { label: "Uruguay", value: "Uruguay Time" },
  { label: "Brunei Darussalam", value: "Brunei Darussalam Time" },
  { label: "Nauru", value: "Nauru Time" },
  { label: "Papua New Guinea", value: "Papua New Guinea Time" },
  { label: "Tonga", value: "Tonga Time" },
  { label: "Solomon Islands", value: "Solomon Islands Time" },
  { label: "Vanuatu", value: "Vanuatu Time" },
  { label: "Fiji", value: "Fiji Time" },
  { label: "Palau", value: "Palau Time" },
  { label: "Wallis and Futuna", value: "Wallis and Futuna Time" },
  { label: "Cook Islands", value: "Cook Islands Time" },
  { label: "Niue", value: "Niue Time" },
  { label: "Samoa Standard", value: "Samoa Standard Time" },
  { label: "Gilbert Islands", value: "Gilbert Islands Time" },
  { label: "New Caledonia", value: "New Caledonia Time" },
  { label: "Tuvalu", value: "Tuvalu Time" },
  { label: "Tahiti", value: "Tahiti Time" },
  { label: "Pitcairn Islands", value: "Pitcairn Islands Time" },
  { label: "Kosrae", value: "Kosrae Time" },
  { label: "Marshall Islands", value: "Marshall Islands Time" }
];

export default function TestModeModule({ id }) {
  const [productId, setProductId] = useState(null);
  const [product, setProduct] = useState([]);
  const [testModeOn, setTestModeOn] = useState(false);
  const [testModeExpiry, setTestModeExpiry] = useState(dayjs(new Date().setHours(new Date().getHours() + 1)));
  const [timeZone, setTimeZone] = useState("Eastern Standard Time");
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("Enable Test Mode?");
  const [dialogText, setDialogText] = useState("Notifications will be disabled for all users except for the provided email until the provided time.");

  const [email, setEmail] = useState('');
  const [validEmail, setValidEmail] = useState(false);
  const [emailFocus, setEmailFocus] = useState(false);

  const [phone, setPhone] = useState(null);
  const [validPhone, setValidPhone] = useState(false);
  const [phoneFocus, setPhoneFocus] = useState(false);

  const fetchData = () => {
    setLoading(true);

    try {
        const pcEndpoint = `api/ProductConfiguration/productConfig/${id}`;
        axios.get(pcEndpoint)
            .then((response) => {
                setProductId(response.data.productId);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
      }
      catch (error) {
        console.error(`Error fetching the config info: ${error}`);
      }

  }

  const fetchProduct = () => {
    setLoading(true);

    try {
        const endpoint = `api/Product/getProduct/${productId}`;
        axios.get(endpoint)
            .then((response) => {
                loadData(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
      }
      catch (error) {
        console.error(`Error fetching the config info: ${error}`);
      }

  }

  const loadData = (data) => {
    setProduct(data);
    data.testMode ? handleTestModeOn() : handleTestModeOff(); 
    setTestModeExpiry(data.testModeExpiryTime ? dayjs(new Date(data.testModeExpiryTime).getTime() - new Date(data.testModeExpiryTime).getTimezoneOffset() * 60000) : dayjs(new Date().setHours(new Date().getHours() + 1)));
  }

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleCleanUp = () => {
    setEmail('');
    setPhone(null);
  };

  const handleTestModeSwitch = () => {
    if (testModeOn) {
      handleTestModeOff();
    } else {
      handleTestModeOn();
    }

    const updatedStatus = {
      productId: productId,
      testMode: !testModeOn,
      testModeExpiryTime: testModeExpiry ? new Date(testModeExpiry) : null,
      testEmail: email ? email : null,
      testPhone: phone ? phone.replace(/-/g, ' ').replace(/[^0-9]/g, '') : null,
      testModeTimeZone : timeZone
    };

    axios.post("/api/Product/updateProductTestMode", updatedStatus)
        .then(() => {
        })
        .catch((error) => {
            console.error(error);
            alert(error.response?.data || "Error updating test mode. Please try again.");
        })
        .finally(() => {
          handleCloseDialog();
          handleCleanUp();
          setLoading(false);
        });
  }

  const handleOutOfTime = () => {
    handleTestModeSwitch();
  }

  const handleTestModeOn = () => {
    setTestModeOn(true);
    setDialogTitle("Disable Test Mode?");
    setDialogText("Notifications will be enabled for all users.");
  }

  const handleTestModeOff = () => {
    setTestModeOn(false);
    setDialogTitle("Enable Test Mode?");
    const text = "Notifications will be disabled for all users except for the provided email and phone number until the provided time.\nATTENTION: An email and text message will be sent to the provided email and phone number to confirm disabled notifications."
    setDialogText(text.split('\n').map(str => <p>{str}</p>));
  }

  const handlePhone = (phoneNumber) => {
    setValidPhone(validator.isMobilePhone(phoneNumber))
    setPhone(phoneNumber);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (productId) {
      fetchProduct();
    }
    // eslint-disable-next-line
  }, [productId])

  useEffect(() => {
    setValidEmail(EMAIL_REGEX.test(String(email).toLowerCase()));
  }, [email]);

  return (
    <>
      <Stack 
        component={Paper}
        p={3} 
        width={'100%'}
        flexDirection={'row'} 
        justifyContent={'space-between'}
      >
        <Stack flexDirection={'row'} alignItems={'center'}>
          <Typography variant='h6'>
            {product.productName} Test Mode
          </Typography>
          <Switch checked={testModeOn} onChange={handleOpenDialog}/>
        </Stack>
        <Stack flexDirection={'row'} alignItems={'center'}>
          {testModeOn && (
            <>
              <Typography variant='h6'>
                Test Mode for {product.productName} will be Automatically Disabled in&nbsp;
              </Typography>
              <Countdown 
                date={testModeExpiry + 0}
                renderer={props => <Typography variant='h6'>{zeroPad((props.days*24) + props.hours)}:{zeroPad(props.minutes)}:{zeroPad(props.seconds)}</Typography>}
                onComplete={handleOutOfTime}
              />
            </>
          )}
        </Stack>
      </Stack>

      <Dialog open={openDialog} onSubmit={handleTestModeSwitch} sx={{ mt: 3 }}>
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent>
          {dialogText}
        </DialogContent>
          {dialogTitle === "Enable Test Mode?" && (
            <>
              <Stack style={{ paddingLeft: "5%", paddingRight: "5%"}}>
                <TextField
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  error={!validEmail && emailFocus}
                  helperText={!validEmail && emailFocus ? "Invalid email" : ""}
                  onFocus={() => setEmailFocus(true)}
                  onBlur={() => setEmailFocus(false)}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Stack>
              <Stack style={{ paddingLeft: "5%", paddingRight: "5%", paddingTop: "5%" }}>
                <MuiPhoneNumber
                  required
                  fullWidth
                  variant="outlined"
                  label="Phone Number"
                  name="phone"
                  value={phone}
                  defaultCountry={'us'}
                  preferredCountries={['us', 'ca', 'fr']}
                  disableAreaCodes={true}
                  error={!validPhone && phoneFocus}
                  helperText={!validPhone && phoneFocus ? "Invalid phone number" : ""}
                  onFocus={() => setPhoneFocus(true)}
                  onBlur={() => setPhoneFocus(false)}
                  onChange={handlePhone}
                />
              </Stack>
              <Stack style={{ paddingLeft: "5%", paddingRight: "5%", paddingTop: "5%" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    required
                    value={testModeExpiry}
                    onChange={(value) => setTestModeExpiry(value)}
                  />
                </LocalizationProvider>
              </Stack>
              <Stack style={{ paddingLeft: "5%", paddingRight: "5%", paddingTop: "5%" }}>
                <FormControl fullWidth>
                  <InputLabel>Select Time Zone</InputLabel>
                  <Select
                    value={timeZone}
                    onChange={(e) => setTimeZone(e.target.value)}
                    label="Select Time Zone"
                    >
                    {timeZones.map((tz) => (
                      <MenuItem key={tz.value} value={tz.value}>{tz.label}</MenuItem>
                    ))}
                  </Select>
              </FormControl>
            </Stack>
            </>
          )}
        <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              Close
            </Button>
            <Button onClick={handleTestModeSwitch} color="primary" disabled={ !validEmail && !validPhone && !testModeOn ? true : false }>
              Confirm
            </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}